import React from "react";
import "../styles/deleteconfirmationmodal.css";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  confirmText = "Delete",
  cancelText = "Cancel",
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={handleOverlayClick}>
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <h3>{title}</h3>
          <button
            className="delete-modal-close-btn"
            onClick={handleCancel}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <div className="delete-modal-body">
          <div className="delete-modal-icon">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#EF4444"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <p className="delete-modal-message">
            {message}
            {itemName && (
              <span className="delete-modal-item-name"> "{itemName}"</span>
            )}
            ?
          </p>

          <p className="delete-modal-warning">This action cannot be undone.</p>
        </div>

        <div className="delete-modal-actions">
          <button
            className="delete-modal-cancel-btn"
            onClick={handleCancel}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            className="delete-modal-confirm-btn"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="delete-modal-loading">
                <div className="delete-modal-spinner"></div>
                Deleting...
              </span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
